import type { PlatformFilter } from "./catalog";
import type { FilterName, SortName } from "./types";

const KEY = "pt-wishlist-catalog-v1";
export interface CatalogState { query: string; filter: FilterName; sort: SortName; platform: PlatformFilter; scrollY: number; anchorId: number | null; anchorTop: number }
const DEFAULTS: CatalogState = { query: "", filter: "all", sort: "default", platform: "all", scrollY: 0, anchorId: null, anchorTop: 0 };
export function readCatalogState(): CatalogState {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    if (!saved || !["all", "sale", "russian", "missing", "upcoming", "ps_plus"].includes(saved.filter)
      || !["default", "title", "price", "discount"].includes(saved.sort) || !["all", "pc", "ps"].includes(saved.platform)) return { ...DEFAULTS };
    return { ...DEFAULTS, ...saved, query: typeof saved.query === "string" ? saved.query : "", scrollY: Number.isFinite(saved.scrollY) ? Math.max(0, saved.scrollY) : 0,
      anchorId: Number.isSafeInteger(saved.anchorId) ? saved.anchorId : null, anchorTop: Number.isFinite(saved.anchorTop) ? saved.anchorTop : 0 };
  } catch { return { ...DEFAULTS }; }
}
export function saveCatalogState(state: CatalogState): void {
  try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch { /* Storage is optional. */ }
}
export function clearCatalogState(): void { try { sessionStorage.removeItem(KEY); } catch { /* Storage is optional. */ } }
